import { c as _c } from "react/compiler-runtime";
import { Info } from "@icon-park/svg";
import { FC, PropsWithChildren } from "react";
import Icon from "../Icon";
import Popover from "../Popover";
import styles from "./OptionCard.module.css";
const OptionCardInfo: FC<PropsWithChildren> = t0 => {
  const $ = _c(5);
  const {
    children
  } = t0;
  let t1;
  if ($[0] !== children) {
    t1 = <p className="text-body-2">{children}</p>;
    $[0] = children;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <span className={styles.info} onClick={_temp} role="none"><Icon icon={Info} size="28" /></span>;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] !== t1) {
    t3 = <Popover variant="white" trigger="hover" content={t1}>{t2}</Popover>;
    $[3] = t1;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  return t3;
};
export default OptionCardInfo;
function _temp(e) {
  return e.preventDefault();
}